export default __webpack_public_path__ + "static/media/red.9167ee44.svg";